/**
 * Where in-app voice input can actually run.
 *
 * `webkitSpeechRecognition` is a Safari/Chrome browser API. Inside the app's
 * WebView the object is sometimes present but never functional, so feature
 * detection alone is not enough — the host has to be checked too.
 *
 * IMPORTANT: the shipped native app is Expo + react-native-webview, which
 * injects `window.ReactNativeWebView`. It does NOT define `window.Capacitor`,
 * so a Capacitor-only check silently fails to hide the button in the real app.
 * Both are checked so this keeps working if the native shell ever changes.
 *
 * TODO: replace with @capacitor-community/speech-recognition for native iOS
 * voice (or expo-speech-recognition while the shell is Expo).
 */

export function isNativeWebView() {
  if (typeof window === 'undefined') return false
  return window.ReactNativeWebView !== undefined || window.Capacitor !== undefined
}

export function isWebSpeechAvailable() {
  if (typeof window === 'undefined') return false
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
  if (!SpeechRecognition) return false
  if (isNativeWebView()) return false
  return true
}

export function getSpeechRecognition() {
  if (typeof window === 'undefined') return null
  return window.SpeechRecognition || window.webkitSpeechRecognition || null
}

/**
 * Voice is not actually lost on the native app — iOS and Android keyboards
 * both have a dictation key that types straight into any focused input. The
 * button is hidden there, so the placeholder points at the keyboard instead
 * of leaving people thinking the feature is missing.
 */
export function composerPlaceholder(name) {
  return isNativeWebView()
    ? `Tell Ginie about ${name}… (tap 🎤 on your keyboard to speak)`
    : `Tell Ginie about ${name}…`
}
